import React from 'react';

import { SvgProps } from '../enums';

export const FlagRW: React.FC<SvgProps> = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_270_55096"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="12"
    >
      <rect width="16" height="12" fill="white" />
    </mask>
    <g mask="url(#mask0_270_55096)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0V12H16V0H0Z"
        fill="#FECA00"
      />
      <mask
        id="mask1_270_55096"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="12"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V12H16V0H0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_270_55096)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V7H16V0H0Z"
          fill="#3CA5D9"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 9V12H16V9H0Z"
          fill="#5A962A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M12.0409 5.9328C12.0243 5.9332 12.0077 5.9334 11.991 5.9334C11.9767 5.9334 11.9625 5.93325 11.9483 5.93296L11.6461 6.91988L11.5821 5.89189C11.5515 5.88558 11.5212 5.87857 11.4911 5.87088L10.9677 6.76085L11.1449 5.74749C11.1164 5.73425 11.0882 5.72035 11.0605 5.70582L10.3447 6.45137L10.7529 5.50697C10.728 5.48744 10.7036 5.46734 10.6798 5.44669L9.81068 6.00811L10.4269 5.18374C10.407 5.15884 10.3877 5.13345 10.3691 5.1076L9.39437 5.45497L10.1846 4.79476C10.1709 4.76567 10.1579 4.73619 10.1456 4.70635L9.11825 4.82178L10.0399 4.36022C10.0334 4.32861 10.0276 4.29672 10.0227 4.26458L8.99719 4.14267L10.001 3.90393C10.002 3.87127 10.0039 3.83881 10.0065 3.80657L9.03773 3.45425L10.0692 3.45093C10.0779 3.4193 10.0873 3.38799 10.0975 3.35702L9.23767 2.79363L10.2423 3.02574C10.2581 2.99707 10.2746 2.96884 10.2919 2.94107L9.58624 2.19643L10.5104 2.65182C10.5324 2.6277 10.5549 2.60412 10.5781 2.5811L10.0646 1.69484L10.8582 2.34916C10.8851 2.33076 10.9124 2.31301 10.9402 2.29591L10.6471 1.31591L11.267 2.13406C11.2973 2.12238 11.328 2.11141 11.359 2.10117L11.3022 1.08006L11.7152 2.01872C11.7471 2.01436 11.7792 2.01074 11.8115 2.00788L11.9946 1L12.1778 2.00854C12.21 2.0115 12.2419 2.01521 12.2736 2.01966L12.6871 1.08006L12.6302 2.10352C12.6606 2.11372 12.6908 2.12462 12.7206 2.13622L13.3421 1.31591L13.0479 2.29967C13.075 2.31645 13.1016 2.33385 13.1278 2.35186L13.9246 1.69484L13.4086 2.58566C13.4309 2.60801 13.4527 2.63089 13.4739 2.65427L14.403 2.19643L13.693 2.94567C13.7095 2.97244 13.7254 2.99963 13.7406 3.02721L14.7516 2.79363L13.8858 3.3609C13.8955 3.3906 13.9045 3.42061 13.9129 3.45091L14.9515 3.45425L13.9757 3.80912C13.9782 3.83995 13.98 3.87099 13.981 3.9022L14.9921 4.14267L13.9592 4.26546C13.9545 4.29619 13.949 4.3267 13.9428 4.35695L14.871 4.82178L13.8367 4.70558C13.825 4.73421 13.8126 4.7625 13.7995 4.79044L14.5949 5.45497L13.6144 5.10556C13.5965 5.1305 13.5779 5.15501 13.5588 5.17907L14.1786 6.00811L13.3054 5.44402C13.2822 5.46412 13.2586 5.48369 13.2345 5.50273L13.6445 6.45137L12.9264 5.7033C12.8992 5.71761 12.8717 5.73131 12.8438 5.74438L13.0215 6.76085L12.4972 5.86927C12.4675 5.87697 12.4375 5.88401 12.4072 5.89037L12.3432 6.91988L12.0409 5.9328ZM11.973 5.20742C12.6733 5.20742 13.241 4.64796 13.241 3.95784C13.241 3.26772 12.6733 2.70827 11.973 2.70827C11.2727 2.70827 10.705 3.26772 10.705 3.95784C10.705 4.64796 11.2727 5.20742 11.973 5.20742ZM12.7023 3.99442C12.7023 4.3891 12.3824 4.70904 11.9877 4.70904C11.593 4.70904 11.2731 4.3891 11.2731 3.99442C11.2731 3.59975 11.593 3.27981 11.9877 3.27981C12.3824 3.27981 12.7023 3.59975 12.7023 3.99442Z"
          fill="#FFDC17"
        />
      </g>
    </g>
  </svg>
);
